var _circle, _circle2, _circle3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMoreoptionsbutton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "More_options_button",
    "data-name": "More options button",
    xmlns: "http://www.w3.org/2000/svg",
    width: 27,
    height: 7,
    viewBox: "0 0 27 7",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_419",
    "data-name": "Ellipse 419",
    cx: 3.5,
    cy: 3.5,
    r: 3.5,
    transform: "translate(27) rotate(90)",
    fill: "#3c3c3b"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_420",
    "data-name": "Ellipse 420",
    cx: 3.5,
    cy: 3.5,
    r: 3.5,
    transform: "translate(17) rotate(90)",
    fill: "#3c3c3b"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_421",
    "data-name": "Ellipse 421",
    cx: 3.5,
    cy: 3.5,
    r: 3.5,
    transform: "translate(7) rotate(90)",
    fill: "#3c3c3b"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoreoptionsbutton);
export default __webpack_public_path__ + "static/media/More options button.499c06a7a011c2939f1239dc10f3fd9a.svg";
export { ForwardRef as ReactComponent };